<div class="db-domains-table-container">
  <div class="db-domains-table-header">
    <div class="products-table-row heads">
      <span *ngFor="let head of heads" [innerHTML]="head | dbText"></span>
      <div class="reload-domains-container" (click)="reloadDomains()">
        <i class="db-icon db-icon-reoptimize-icon" *ngIf="!listLoading"></i>
        <db-loading-circular-spinner color="dark"
                                     [size]="'xs_small'"
                                     *ngIf="listLoading"></db-loading-circular-spinner>
        <span *ngIf="!isMobile">{{ 'text_recheckDomainStatuses' | dbText }}</span>
      </div>
    </div>
  </div>

  <ng-content></ng-content>
</div>
